import { Box, Stack, styled } from "@mui/material";
import React from "react";
import FeatherIcon from "feather-icons-react";
import { useThemeMode } from "../theme";
import { THEME_MODES } from "../../helpers/constant";

const IncreaseDecreaseArrows = ({
  increase,
  percentage,
  percentageFontSize,
  percentageFontWeight,
  percentageColor,
  size,
}) => {
  const { colours, themeMode, FONT } = useThemeMode();
  const Item = styled("div")({
    fontWeight: percentageFontWeight || 400,
    fontSize: percentageFontSize || FONT.SIZE_13,
  });

  return (
    <Stack
      direction="row"
      gap={percentageFontSize ? 0.5 : 0.25}
      sx={{
        alignItems: "center",
        fontSize: size || FONT.SIZE_16,
        color: increase ? colours.success100 : colours.critical100,
      }}
    >
      <Box
        flexShrink={0}
        display="inline-flex"
        alignItems="center"
        justifyContent="center"
        sx={{
          ...(themeMode === THEME_MODES.COLOR_VISION && {
            width: 20,
            height: 20,
            borderRadius: '3px',
            marginRight: .25,
            backgroundColor: increase ? colours.success100 : colours.critical100,
            color: colours.white,
          }),
        }}
      >
        <FeatherIcon
          size={size || 16}
          icon={increase ? "arrow-up" : "arrow-down"}
        />
      </Box>
      <Item sx={{ color: percentageColor }}>{percentage}</Item>
    </Stack>
  );
};

export default IncreaseDecreaseArrows;
